export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7920.6ba431c2.jpg";